import { OverlappingEmpForm } from '~/features/OverlappingEmploymentDialog/hooks/useOverlappingEmploymentForm';
import {
  SalarySubmitData,
  SalarySubmitData_Components,
  submitSalaryProposal,
} from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposal/components/Forms/SalaryProposalForm/data';

const mapOverlappingFormToSalaryProposalPayload = (
  employmentId: number,
  form: OverlappingEmpForm,
  loginId: number,
  iHR: boolean,
): SalarySubmitData | FormData => {
  const {
    fSalaryProposalSalary,
    fSalaryProposalComponents,
    fEmplAttachment,
    ...directPassProps
  } = form.overlappingEmployment.startingSalary;

  const convertToNumber = (value: string) => {
    const number = parseInt(value);
    return isNaN(number) ? 0 : number;
  };

  const hourlyComps: SalarySubmitData_Components = (() => {
    const {
      fSalaryComp1Amount,
      fSalaryComp2Amount,
      fSalaryComp3Amount,
      fSalaryComp4Amount,
      ...salaryComRest
    } = fSalaryProposalComponents;

    return {
      fSalaryComp1Amount: convertToNumber(fSalaryComp1Amount),
      fSalaryComp2Amount: convertToNumber(fSalaryComp2Amount),
      fSalaryComp3Amount: convertToNumber(fSalaryComp3Amount),
      fSalaryComp4Amount: convertToNumber(fSalaryComp4Amount),
      ...salaryComRest,
    };
  })();

  const payloadCommon: Omit<SalarySubmitData, 'fEmplAttachment'> = {
    ...directPassProps,
    ...hourlyComps,
    fSalaryProposalSalary: convertToNumber(fSalaryProposalSalary),
    fEmplId: employmentId,
    fSalaryProposalHrId: iHR ? loginId : -1,
    fSalaryProposalHigherMgrId: -1,
    fSalaryProposalManagerId: iHR ? -1 : loginId,
    fSalaryProposalStatus: iHR ? 'HR_APPROVED' : 'PROPOSED',
    fSalaryProposalChange: 0,
    fSalaryProposalChangePct: 0,
  };

  // JSON Payload
  if (!fEmplAttachment) {
    return {
      ...payloadCommon,
      fEmplAttachment: {
        fAttachmentId: -1,
        fAttachmentName: '',
      },
    };
  }

  // FormData payload
  const formData = new FormData();
  if (fEmplAttachment) {
    Object.entries(payloadCommon).forEach((sbData) => {
      if (sbData[1] !== null && sbData[1] !== undefined) {
        formData.append(
          sbData[0],
          typeof sbData[1] === 'string' ? sbData[1] : sbData[1].toString(),
        );
      }
    });
    formData.append('file', fEmplAttachment);
    formData.append('fEmplAttachment.fAttachmentName', fEmplAttachment.name);
  }

  return formData;
};

export const saveSalaryProposal = async (
  employeeId: number,
  employmentId: number,
  form: OverlappingEmpForm,
  loginId: number,
  iHR: boolean,
) => {
  return submitSalaryProposal(
    mapOverlappingFormToSalaryProposalPayload(employmentId, form, loginId, iHR),
    { employeeId, employmentId },
  ).catch((e) => {
    console.log('saveSalaryProposal', e);
  });
};
